import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';

import * as Yup from 'yup';
import { Button, SubmitButton } from 'components';
import { DateSelectionField } from '@app/form';
import { Form, Formik } from 'formik';
import { Trans, useTranslation } from 'react-i18next';
import { PaginatedAvailableDates } from '@app/api';

const useStyles = createUseStyles((theme: Theme) => ({
  formContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.marginBase * 3 + 'px',
  },
  buttonsLine: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginTop: theme.marginBase * 4,
    gap: theme.marginBase,
  },
  button: {
    marginRight: theme.marginBase * 2,
  },
}));

interface Props {
  initialValues: { date: string };
  onSubmit: (values: { date: string }) => any;
  paginatedAvailableDates: PaginatedAvailableDates;
  onRequestClose: () => any;
  duration: number;
}

const validationSchema = Yup.object().shape({
  date: Yup.string().required(),
});

export const MeetingDateForm = ({
  initialValues,
  onSubmit,
  paginatedAvailableDates: { availableDates, hasNextPage, fetchNextPage },
  onRequestClose,
  duration,
}: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      className={classes.formContent}
    >
      <Form>
        {availableDates && (
          <DateSelectionField
            duration={duration}
            dates={availableDates}
            name="date"
          />
        )}
        <div className={classes.buttonsLine}>
          <Button
            variant="transparent"
            color="red"
            text={t('sessions.details.appointmentBooking.buttons.cancel')}
            onClick={() => onRequestClose()}
            className={classes.button}
          />
          <SubmitButton
            color="green"
            text={t('sessions.details.appointmentBooking.buttons.submit')}
          />
          {hasNextPage && (
            <Button variant="muted" onClick={() => fetchNextPage()}>
              <Trans i18nKey="booking.appointment.showMoreAvailabilities" />
            </Button>
          )}
        </div>
      </Form>
    </Formik>
  );
};
